import { render, staticRenderFns } from "./RandomBlog.vue?vue&type=template&id=60c9faf6&scoped=true"
import script from "./RandomBlog.vue?vue&type=script&lang=js"
export * from "./RandomBlog.vue?vue&type=script&lang=js"
import style0 from "./RandomBlog.vue?vue&type=style&index=0&id=60c9faf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c9faf6",
  null
  
)

export default component.exports